module.exports = __webpack_public_path__ + "img/WhatsApp Image 2021-07-08 at 11.41.43.be1b3774.jpeg";